import { useEffect } from 'react';
import L from 'leaflet';

export function useDisableMapEvents(ref) {
  useEffect(() => {
    if (!ref.current) return;
    L.DomEvent.disableClickPropagation(ref.current);
    L.DomEvent.disableScrollPropagation(ref.current);
  }, [ref]);
}